import { CareMapState } from '../caremap/CareMapState';
import { IHeaderTab } from '../HeaderTabs';

export class CommunityTabsProvider {

    static inject = () => [CareMapState];
    constructor(private careMapState: CareMapState) {}

    getTabs = () => {
        const careMap = this.careMapState.getMostRecentCaremap();

        const tabs: IHeaderTab[] = [];
        tabs.push({ label: 'Sharing & Access', url: `/community/${careMap?.careMapId}`, dataId: 'sharing-tab' });
        tabs.push({ label: 'Resources', url: `/resources`, dataId: 'resources-tab' });

        return { tabGroupId: 'community-tabs', tabs };
    };
}
